var ua =  require('@tencent/txv.ua')();

function check(config, callback) {
	var ios = ua.os.iphone;
	var scheme = ios ? config.pkgurl : config.pkg;

	if (!ios && window.QQApi && QQApi.checkAppInstalled) {
		QQApi.checkAppInstalled(scheme, function (r) {
			if (r && !/denied|permission/.test(r) && r != 0) {
				r = r.split('\.');
				r = r[r.length - 1];
				callback(null, 1, r);
			} else {
				callback(null, 0);
			}
		})
	} else if (window.mqq && mqq.app && mqq.app.isAppInstalled) {
		mqq.app.isAppInstalled(scheme, function (rs) {
			callback(null, rs === true || rs && rs.result ? 1 : 0);  //iOS9新增了scheme白名单限制，返回的值不一样做了兼容处理
		});
	} else {
		callback(null, 2);
	}
}

var jsbridge = require("@tencent/txmv-core/jsbridge");
module.exports = function (config, _callback) {
	var callbacked = false;
	//只callback一次
	var callback = function () {
		if (callbacked) {
			return;
		}
		callbacked = true;
		_callback.apply(this, arguments);
	};

	jsbridge(function(bridge) {
		if (bridge) {
			check(config, callback);
		} else {
			callback(null, 2);
		}
	});
	setTimeout(function () {
		callback(null, 2);
	}, 6000);
};